/**
 * Allowlisted remote support actions — must match backend REMOTE_SUPPORT_ACTION_REGISTRY.
 * UI must never offer free-text / arbitrary shell commands.
 */

export interface RemoteSupportActionDef {
  id: string;
  label: string;
  description: string;
}

export const REMOTE_SUPPORT_ACTION_REGISTRY: Record<string, RemoteSupportActionDef> = {
  REFRESH_AGENT_STATUS: {
    id: 'REFRESH_AGENT_STATUS',
    label: 'Refresh Agent Status',
    description: 'Ask the Companion to refresh and publish health/status.',
  },
  RESTART_TEKS_COMPANION: {
    id: 'RESTART_TEKS_COMPANION',
    label: 'Restart TEKS Companion',
    description: 'Request a controlled Companion process restart (not Windows reboot).',
  },
  REQUEST_AGENT_SYNC: {
    id: 'REQUEST_AGENT_SYNC',
    label: 'Request Agent Sync',
    description: 'Trigger work-session / monitoring config sync.',
  },
  OPEN_TEKS_TIME: {
    id: 'OPEN_TEKS_TIME',
    label: 'Open TEKS TIME',
    description: 'Open the TEKS TIME web app in the employee browser.',
  },
  COLLECT_DIAGNOSTICS: {
    id: 'COLLECT_DIAGNOSTICS',
    label: 'Collect Diagnostics',
    description:
      'Build a sanitized TEKS diagnostics bundle and show recent redacted agent.log lines inline.',
  },
  REFRESH_MONITORING_CONFIGURATION: {
    id: 'REFRESH_MONITORING_CONFIGURATION',
    label: 'Refresh Monitoring Configuration',
    description: 'Reload monitoring configuration from the server.',
  },
};

export const REMOTE_SUPPORT_ACTION_LIST: RemoteSupportActionDef[] = Object.values(
  REMOTE_SUPPORT_ACTION_REGISTRY,
);

export function isAllowlistedSupportAction(actionId: string): boolean {
  return Object.prototype.hasOwnProperty.call(REMOTE_SUPPORT_ACTION_REGISTRY, actionId);
}
